var $ = require('jquery');
require('datatables.net');

function init() {
    $.fn.dataTable.Api.register('processing()', function (show) {
        return this.iterator('table', function (ctx) {
            ctx.oApi._fnProcessingDisplay(ctx, show);
        });
    });
}

module.exports = init;


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/web_modules/coolfit/datatables/datatables-processing.js
// module id = 5
// module chunks = 1